@if (resolvedProduct(); as product) {
  <sd-media class="product-compact-image" [container]="product.images?.PRIMARY" [alt]="product.name"></sd-media>
  <span class="product-compact-name text-b1-s-500">{{ product.name }}</span>
}
